export default __webpack_public_path__ + "assets/models/7a0adf74ec6333dbeefffd312f520ead.glb";